module.exports = __webpack_public_path__ + "img/paypal.161e7fe0.png";